import { Injectable } from '@angular/core';
import { BackendService } from 'src/app/core/services/backend-prod.service';

@Injectable({
  providedIn: 'root'
})

export class AuthenticationService {

  constructor(private backendService: BackendService) { }
  
  login(user) {
    return this.backendService.Post('login', user);
  }

  forgotPassword(email) {
    return this.backendService.Post('forgotPassword', email);
  }

  changePassword(email, token) {
    return this.backendService.Post('changePassword', email, { headers: { 'Authorization': token } });
  }
}
